/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react';
import { NavBar } from './styles/NavBar.styled';
import { ShowCaseContact } from './styles/ShowCase.styled';
import { ContactInfo } from './styles/ContactInfo.styled';
import { MapSection } from './styles/MapSection.styled';
import { Footer } from './styles/Footer.styled';
// import logo from './assets/rade-color.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
const rootUrl = 'https://rade-nodejs.onrender.com' || 'http://localhost:5500';

const Contact = () => {
  //Title Page
  useEffect(() => {
    document.title =
      'Contact Us - Have a question about our services?';
  }, []);



  const [formData, setFormData] = useState({
    email: '',
    name: '',
    message: '',
  });
  const [status, setStatus] = useState('');

 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); //Prevents the page from refreshing
    setStatus('sending...');

    try {
      const url = `${rootUrl}/api/send-email`;
      // const url = `/api/v1/auth/login`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (response.ok) {
        setStatus('Email sent successfully!');
        //clear the form
        setFormData({ email: '', name: '', message: '' });
      } else {
        setStatus(`Error: ${data.message}`);
      }
    } catch (error) {
      console.error('NetworkError:', error);
      setStatus('Failed to connect to server.');
    }
  };

  return (
    <>
      <NavBar></NavBar>
      <main>
        <ShowCaseContact>
          <div className="center">
            <div className="titleBox">
              <h1>Contact Us</h1>
              <p>
               We deliver facilities services and management throughout the UK
              </p>
            </div>
          </div>
        </ShowCaseContact>
        <ContactInfo>
          <div className="container">
            <div className="row">
              <div className="col-1">
                {/* <h3>Contact Information</h3> */}
                <h1>Have a question about our services?</h1>
                <p>
                  Our dedicated team is ready to help. Simply complete the
                  contact form, and a member of our staff will reach out to you
                  shortly.
                </p>
                <ul>
                  <li>
                    <span>
                      <FontAwesomeIcon icon={faLocationDot} />
                    </span>
                    <p>
                      Spaces Acero, 1 concourse way Sheffield City centre S1 2BJ
                    </p>
                  </li>
                  <li>
                    <span>
                      <i class="fa-solid fa-envelope"></i>
                    </span>
                    <a href="mailto:info@radeintegratedservices.co.uk">
                      info@radeintegratedservices.co.uk
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-2">
                <h2>Get in Touch</h2>
                <form onSubmit={handleSubmit}>
                  <textarea
                    name="message"
                    required
                    placeholder="Your Enquiry*"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                  <div className="mail">
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name*"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="Your Email*"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <button type="submit">Send Message</button>
                  {status && <p>{status}</p>}
                </form>
              </div>
            </div>
          </div>
        </ContactInfo>
        <MapSection>
          <div className="container">
            <h2>Areas We Cover</h2>
            <p>
              All cities in South Yorkshire, West Yorkshire, North Yorkshire,
              East Yorkshire, East Midlands and Greater Manchester.
            </p>
            <div class="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d607387.8547864086!2d-1.5231894547241804!3d53.51118315676702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sng!4v1746381350417!5m2!1sen!2sng"
                allowfullscreen=""
                loading="lazy"
                reerrorpolicy="no-referrer-when-downgrade"
                title="map"
              ></iframe>
            </div>
          </div>
        </MapSection>
      </main>
      <Footer></Footer>
    </>
  );
};

export default Contact;
